var _path, _mask, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLookout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 80,
    viewBox: "0 0 126 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.246 64.9185L56.5411 39.1082L101.246 13.2978L101.246 64.9185Z",
    stroke: "black",
    strokeWidth: 9
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1_7049",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.729065,
    y: 0.304932,
    width: 78.9144,
    height: 78.9144,
    rx: 6
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.729065,
    y: 0.304932,
    width: 78.9144,
    height: 78.9144,
    rx: 6,
    fill: "white",
    stroke: "black",
    strokeWidth: 18,
    mask: "url(#path-2-inside-1_1_7049)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookout);
export default __webpack_public_path__ + "static/media/Lookout.cbdce56f.svg";
export { ForwardRef as ReactComponent };